import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetChannelTableData } from '@/modules/manage-player/type'
import { columns, writeAccessorKeys } from './constants'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'

interface GetChannelTableProps {
	data: GetChannelTableData[]
	total: number
	isLoading?: boolean
}

export default function GetChannelTable({
	data,
	total,
	isLoading,
}: GetChannelTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_PLAYER,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder="ค้นหาช่องทาง" />
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
